import $ from 'jquery';
import Helpers from '../helpers/util';

const $el = $('.js-complete');
const $cta = $('.js-complete__cta');

class Complete {
	constructor($el, $cta) {
		this.$el = $el;
		this.$inner = $el.find('.complete__inner');
		this.$close = $el.find('.js-complete__close');
		this.$cta = $cta;

		this.clsActive = 'is-active';
		this.clsAnimating = 'is-animating';

		this.attachHandlers();
	}

	attachHandlers() {
		// Open
		this.$cta.on('click', (evt) => {
			evt.preventDefault();
			this.$el.addClass(this.clsActive);
			this.$el.addClass(this.clsAnimating);
		});

		// Close
		this.$el.on('click', () => {
			this.$el.removeClass(this.clsActive);
			this.$el.addClass(this.clsAnimating);
		});

		// Close
		this.$close.on('click', (evt) => {
			evt.preventDefault();
			this.$el.removeClass(this.clsActive);
			this.$el.addClass(this.clsAnimating);
		});

		// Stop props on children
		this.$inner.on('click', (evt) => {
			evt.stopPropagation();
		});

		// On Animation finish, remove the 'is-animating' class.
		// This close moves the animation in frame for entire duration
		Helpers.dom.onTransitionEndAlways(this.$el, () => {
			this.$el.removeClass(this.clsAnimating);
		});
	}
}

const _init = () => {
	if ($el.length && $cta.length) {
		new Complete($el, $cta);
	}
};

_init();
